import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';

import { PATH } from '../../../constants/path';
import { PAYPAL } from '../../../constants/paymentMethods';
import { VALIDATED } from '../../../services/checkout/constants';
import { MODAL_TYPE_KYC } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import { createPaypalOrder, capturePaypalOrder } from '../../../services/paypal/utils';

import { LoadingComponent } from '../../loading/LoadingComponent';

const PaypalButton = ({
    userInfo,
    partnerId,
    kycNeeded,
    i18n,
    order,
    ebonPaymentConfig,
    paymentMethods,
    paypalCost,
    showModal
}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [{ isPending }] = usePayPalScriptReducer();

    const disabled = isPending || loading || kycNeeded;

    const paypalAllowed = ebonPaymentConfig.paypalAllowed && paymentMethods.includes(PAYPAL);

    /* Step 1 */
    const onCreateOrder = async () => {
        setLoading(true);
        try {
            const widgetLink = await createPaypalOrder(userInfo, partnerId, order.id);
            if (widgetLink) {
                return widgetLink;
            }
            setLoading(false);
            setError(i18n.DEFAULT_ERROR_MESSAGE);
        } catch (e) {
            setLoading(false);
            setError(e.message);
            throw e;
        }
    };

    /* Step 2 */
    const onApprove = async data => {
        const errorUrl = `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${order.id}`;
        try {
            const response = await capturePaypalOrder(data.orderID, userInfo, partnerId);
            if (
                response &&
                response.status === 200 &&
                response.ebonOrderUuid &&
                response.ebonOrderState === VALIDATED
            ) {
                const successUrl = `${PATH.EBON_CONFIRMATION_PATH}-${partnerId}?orderId=${response.ebonOrderUuid}&paypal=${paypalCost}&ref=${data.orderID}`;
                window.location.href = successUrl;
            } else if (response && response.status === 412) {
                setLoading(false);
                console.error('Failed to capture PayPal order :', data.orderID);
                setError(i18n.PRECONDITION_FAILED_ERROR_MESSAGE);
            } else {
                console.error('Failed to capture PayPal order :', data.orderID);
                window.location.href = errorUrl;
            }
        } catch (e) {
            window.location.href = errorUrl;
        }
    };

    const onError = err => {
        setLoading(false);
        console.error('PayPal error : ', err);
        setError(i18n.DEFAULT_ERROR_MESSAGE);
    };

    const onCancel = () => {
        setLoading(false);
        setError(null);
    };

    const onClick = () => {
        if (kycNeeded) {
            showModal(MODAL_TYPE_KYC, {
                hideCloseButton: false,
                useCase: null
            });
        }
    };

    return (
        <div style={{ marginTop: '10px' }}>
            {paypalAllowed && (
                <PayPalButtons
                    key={kycNeeded ? 'kyc-needed' : 'kyc-done'}
                    style={{
                        shape: 'rect',
                        layout: 'vertical'
                    }}
                    createOrder={kycNeeded ? undefined : onCreateOrder}
                    onApprove={onApprove}
                    onError={onError}
                    onCancel={onCancel}
                    disabled={disabled}
                    onClick={onClick}
                />
            )}

            {isPending && <LoadingComponent />}

            {error && <p className="error">{error}</p>}
        </div>
    );
};

PaypalButton.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    kycNeeded: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON.PAYPAL,
        order: state.ebon.createdOrder,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig,
        paymentMethods: state.ebon.lock[0].paymentMethods || [],
        paypalCost: state.ebon.ebons.ebonPaymentConfig.paypalCost
    };
};

const mapDispatchToProps = {
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(PaypalButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/PaypalButton.js